import TabPage from "./tab-page";
// bao migrate - module not found: import "services/bao-template-engine";
import * as ko from "knockout";
import Bao from "./../services/bao-service";
import * as moment from "moment";

class BaseStartModule {
    constructor(serverModel, tabPage) {
        this.TabPage = tabPage;
        this.subscriptions.push(this.WebUrl.subscribe(() => {
            this.LoadHtml();
        }));
        ko.map.fromJS(serverModel, this);
    }
    private subscriptions: KnockoutSubscription[] = [];
    WebUrl = ko.observable();
    Key = ko.observable();
    TemplateName = ko.observable();
    TabPage: TabPage;
    ValidDateJs = ko.observable(moment().format(Bao.Utils.DateTimeFormat));

    Refresh() { }
    ;
    LoadHtml() {
        return Bao.get(this.WebUrl(), (result) => {
            var templateName = "Module_" + this.Key();
            Bao.Templates[templateName] = result;
            this.TemplateName(templateName);
        });
    }
}
export default BaseStartModule;